// PhonePe Payment Gateway Configuration - PRODUCTION
// SECURITY: Credentials loaded from environment variables

export const PHONEPE_CONFIG = {
  // Production Credentials (RAPSAONLINE)
  MERCHANT_ID: import.meta.env.VITE_PHONEPE_MERCHANT_ID || 'RAPSAONLINE',
  SALT_INDEX: import.meta.env.VITE_PHONEPE_SALT_INDEX || '1',
  SALT_KEY: import.meta.env.VITE_PHONEPE_SALT_KEY || 'ec7f21c7-a192-47bd-b7e9-4cecf8b0c5b3',
  
  // API Endpoints - Production
  API_URL: import.meta.env.VITE_PHONEPE_API_URL || 'https://api.phonepe.com/apis/hermes',
  
  // Callback URLs
  CALLBACK_URL: import.meta.env.VITE_PHONEPE_CALLBACK_URL || 'https://www.rapsapp.in/api/phonepe/callback',
  REDIRECT_URL: import.meta.env.VITE_PHONEPE_REDIRECT_URL || 'https://www.rapsapp.in/order-confirmation',
  
  // Payment Configuration
  MERCHANT_USER_ID: 'RAPSAPP_USER',
  
  // Environment
  ENVIRONMENT: import.meta.env.VITE_PHONEPE_ENVIRONMENT || 'PRODUCTION'
};

// ⚠️ SECURITY NOTE: 
// Salt key is from RAPSAONLINE_1.json - keep this secure and never commit to public repos
